"use strict";

var _defineProperty = require("/home/circleci/repo/web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/circleci/repo/web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useMap = function useMap() {
  var initialMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _react_1$useState = react_1.useState(initialMap),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      map = _react_1$useState2[0],
      _set = _react_1$useState2[1];

  return [map, {
    get: function get(key) {
      return map[key];
    },
    set: function set(key, entry) {
      return _set(Object.assign({}, map, _defineProperty({}, key, entry)));
    },
    remove: function remove(key) {
      var _a = map,
          _b = key,
          omit = _a[_b],
          rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);

      _set(rest);
    },
    reset: function reset() {
      return _set(initialMap);
    }
  }];
};

exports.default = useMap;